<template>
  <div class="component-panel">
    <div class="panel-header">
      <span class="panel-title">Компоненты</span>
      <i class="pi pi-times panel-close" @click="$emit('close')"></i>
    </div>
    <ScrollPanel class="panel-scroll">
      <div class="components-grid">
        <div
          class="component-item"
          v-for="(item, i) in itemList"
          :key="'panel' + item.typeName + i"
          :data-testId="`panel_` + item.typeName"
          @click.prevent="onClickComponent(item.typeName)"
        >
          <div class="component-content">
            <div class="component-preview">
              <component
                :id="'panel' + item.typeName + i"
                :is="componentMap[item.typeName]"
                v-bind="item.attrList"
                :absolut="false"
              />
            </div>
            <span class="component-name">
              {{ item.typeNameRu }}
            </span>
          </div>
        </div>
      </div>
    </ScrollPanel>
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, defineProps, defineEmits  } from 'vue';
import { useStore } from 'vuex';
import EventBus from '@/core/EventBus';

import pipeline_horizontal from './components/pipeline_horizontal.vue';
import pipeline_vertical from './components/pipeline_vertical.vue';
import pipeline_90_rightbottom from './components/pipeline_90_rightbottom.vue';
import pipeline_90_rightup from './components/pipeline_90_rightup.vue';
import pipeline_90_leftbottom from './components/pipeline_90_leftbottom.vue';
import pipeline_90_leftup from './components/pipeline_90_leftup.vue';
import indicator from './components/indicator.vue';
import drawing from './components/drawing.vue';
import icon from './components/icon.vue';
import heading from './components/heading.vue';
import valve from './components/valve.vue';
import cool_pump from './components/cool_pump.vue';
import state_interpreter from './components/state_interpreter.vue';
import progressbar from './components/progressbar.vue';
import button_ from './components/button_.vue';
import editor from './components/editor.vue';
import input_ from './components/input_.vue';
import dropdown_ from './components/dropdown_.vue';
import pipeline_cross from './components/pipeline_cross.vue';
import scnd from './components/scnd.vue';
import submersibl_pump from './components/submersibl_pump.vue';
import vert_pump from './components/vert_pump.vue';
import tank from './components/tank.vue';
import tank_double_level from './components/tank_double_level.vue';
import line_ from './components/line_.vue';
import sign from './components/sign.vue';

const props = defineProps({
  moveable: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close']);

const store = useStore();

const itemList = computed(() => store.getters.components);

const componentMap = {
  pipeline_horizontal,
  pipeline_vertical,
  pipeline_90_rightbottom,
  pipeline_90_rightup,
  pipeline_90_leftbottom,
  pipeline_90_leftup,
  indicator,
  drawing,
  heading,
  valve,
  cool_pump,
  state_interpreter,
  icon,
  progressbar,
  button_,
  editor,
  input_,
  dropdown_,
  pipeline_cross,
  scnd,
  submersibl_pump,
  vert_pump,
  tank,
  tank_double_level,
  line_,
  sign,
  panel: defineAsyncComponent(() => import('./components/panel.vue')),   // TODO почему то без асинхронного импорта раньше не работал
};

const onClickComponent = (name) => {
  let elem;
  itemList.value.forEach((element) => {
    if (element.typeName === name) {
      elem = { ...element };
      elem.attrList = { ...element.attrList };
    }
  });
  if (elem) {
    elem.attrList.width = elem.default.width;
    elem.attrList.height = elem.default.height;
    delete elem.default;
    EventBus.emit('on-create-component-select', elem);
  }
};
</script>

<style lang="scss" scoped>
.component-panel {
  color: var(--text-color);
  background: var(--surface-d);
  border-radius: 4px;
  z-index: 8999;
  width: 15%;
  height: 87vh;
  position: absolute;
  left: 1px;
  top: 114px;
  border: 1px solid var(--primary-color);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;

  .panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 12px;
    background: var(--surface-d);
    border-bottom: 1px solid var(--surface-border);

    .panel-title {
      font-weight: 500;
      font-size: 1.1rem;
    }

    .panel-close {
      cursor: pointer;
      padding: 4px;
      border-radius: 50%;
      transition: all 0.2s;

      &:hover {
        background: var(--surface-hover);
        color: var(--primary-color);
      }
    }
  }

  .panel-scroll {
    flex: 1;
    height: 82%;

    ::v-deep(.p-scrollpanel-bar) {
      background-color: var(--primary-color);
      opacity: 0.6;
      transition: background-color 0.3s;

      &:hover {
        opacity: 1;
      }
    }

    ::v-deep(.p-scrollpanel-bar-y) {
      width: 6px;
    }

    ::v-deep(.p-scrollpanel-content) {
      padding: 2px 2px 2px 2px;
      width: 100%;
    }
  }

  .components-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 8px;
    padding: 4px;
  }

  .component-item {
    border: 1px solid var(--surface-border);
    border-radius: 4px;
    transition: all 0.2s ease;
    background: var(--surface-b);

    &:hover {
      border-color: var(--primary-color);
      background: var(--surface-hover);
      cursor: pointer;
      transform: translateY(-2px);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
  }

  .component-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 8px;
  }

  .component-preview {
    width: 60px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 6px;
  }

  .component-name {
    font-size: 0.95rem;
    text-align: center;
    word-break: break-word;
    line-height: 1.3;
  }
}

@media screen and (max-width: 1054px) {
  .component-panel {
    width: 25%;
    min-width: 200px;
  }
}

@media screen and (max-width: 740px) {
  .component-panel {
    width: 180px;
  }

  .components-grid {
    grid-template-columns: 1fr !important;
  }
}
</style>
